import React from 'react';
import { ItemPhotosModal } from '@/types/modal';
import { CustomModal, HeadingModal } from '@/components/molecules/common/Modal';
import Photos from '@/components/molecules/common/Photos';
import styles from './Modal.module.scss';

const View: React.FC<{ modal: ItemPhotosModal }> = ({ modal }) => {
  const { photos, index, onClose } = modal;

  const body = (
    <div className={styles.itemPhotos}>
      <div className={styles.itemPhotosHeader}>
        <HeadingModal
          title={''}
          onClose={onClose}
        />
      </div>
      <div
        data-cy={'modal-body'}
        className={styles.itemPhotosBody}
      >
        <Photos
          photos={photos}
          index={index}
        />
      </div>
    </div>
  );

  return (
    <CustomModal
      onClose={onClose}
      body={body}
      containerStyle={{ width: 600, height: 'calc(100% - 10rem)', maxHeight: 600 }}
      modalName="item_photos"
    />
  );
};

export default View;
